import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const tasksSlice = createSlice({
  name: "tasks",
  initialState,
  reducers: {},
});

export default tasksSlice.reducer;
export const {} = tasksSlice.actions;
